import { ResultsResponse } from '@dialogue/smartsearch'
import apisauce from 'apisauce'
import url from 'url'

import type { LoginState } from 'APP/Store/Login/types'

interface SmartSearchResponse {
  results: ResultsResponse[]
}

const create = (loginStore: LoginState, source: string) => {
  const authToken = loginStore.accessToken
  const sourceURLObj = url.parse(source, true)
  const baseURL = url.format({
    ...sourceURLObj,
    search: undefined,
    pathname: undefined,
    query: undefined,
  })
  const api = apisauce.create({
    baseURL,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    timeout: 20000,
  })

  // API
  const search = (query: string) => {
    return api
      .get<SmartSearchResponse>(sourceURLObj.pathname ?? '', {
        ...sourceURLObj.query,
        query,
      })
      .then((response) => {
        if (response.ok) {
          if (response.data) {
            return response.data.results
          }
        } else {
          throw response.problem
        }
      })
  }

  return {
    search,
  }
}

export default {
  create,
}
